import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterOutlet } from '@angular/router';
import { MotifToastModule } from '@ey-xd/ng-motif';
import { APP_EVENT, APP_EVENT_KEY } from '@models';
import { TranslatePipe } from '@ngx-translate/core';
import { EventService, MainHelperService } from '@services';
import { ToastService } from '@services/toast.service';
import { FooterComponent, HeaderComponent, SideBarComponent } from '@views';

@Component({
  selector: 'app-main-helper',
  standalone: true,
  imports: [
    FooterComponent,
    HeaderComponent,
    RouterOutlet,
    SideBarComponent,
    MotifToastModule,
    TranslatePipe,
    AsyncPipe,
  ],
  templateUrl: './main.component.html',
  styleUrl: './main.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainComponent implements OnInit {
  #eventService: EventService = inject(EventService);
  #mainHelperService: MainHelperService = inject(MainHelperService);
  #destroyRef: DestroyRef = inject(DestroyRef);
  #toastService: ToastService = inject(ToastService);

  public isMenuOpen = signal<boolean>(false);
  public links = this.#mainHelperService.mainLinks;

  public toastOptions$ = this.#toastService.getToastOptions$();

  ngOnInit(): void {
    this.#initializeTimeoutEvents();
    this.#subscribeToToggleNavMenu();
    this.#mainHelperService.checkPrivacyNotice().pipe(takeUntilDestroyed(this.#destroyRef)).subscribe();
  }

  #initializeTimeoutEvents(): void {
    this.#mainHelperService
      .subscribeToTimeOutEvents()
      .pipe(takeUntilDestroyed(this.#destroyRef))
      .subscribe((event: APP_EVENT): void => this.#mainHelperService.handleTimeOutEvent(event));
  }

  #subscribeToToggleNavMenu(): void {
    this.#eventService.getDistinctEventByKeyValue(APP_EVENT_KEY.TOGGLE_NAV_MENU).subscribe({
      next: (event: APP_EVENT): void => {
        this.isMenuOpen.set(event.value as boolean);
      },
    });
  }

  public onToastHidden(): void {
    this.#toastService.triggerClose();
    this.#toastService.showToast(null);
  }
}
